jQuery(document).foundation();

jQuery(document).ready(function ($) {

  function isInViewport(node) {
    var rect = node.getBoundingClientRect();
    return (
      (rect.height > 0 || rect.width > 0) &&
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Mobile Menu
  $('#offCanvas').on('opened.zf.offCanvas', function () {
    $('#openOffCanvas').addClass('is-active');
  });

  $('#offCanvas').on('closed.zf.offCanvas', function () {
    $('#openOffCanvas').removeClass('is-active');
  });

  $(".accordionToggle").click(function (e) {
    e.preventDefault();

    $(this).parent().find(".accordionContent").slideToggle();


  });
});
